import React from 'react';

const QuickNavigationContext = React.createContext({
  items: [],
  addItem: () => {},
  removeItem: () => {},
  selected: undefined,
  setSelected: () => {},
});

export default QuickNavigationContext;
